export var contextMapping = {
    gas: 'gas',
    electricity: 'energy' || 'energie',
    heating: 'energy',
    autostrom: 'energy' || 'energie',
    telco: 'telco',
    thg: 'thg',
    undefined: 'telco'
};
